import * as Yup from 'yup';

export const visitValidateSchema = Yup.object().shape({
  name: Yup.string().required('Please enter your name'),
  phone: Yup.string().required('Please enter your phone number')
});